/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

export const EventTableActions = ({
  row,
  openEditEventPage,
  openDeleteEventDialog,
  openActivateEventDialog,
  openEventFullDialog,
  openEventNotFullDialog,
  openDuplicateEventPage,
  openEmailAttendeesPage,
  onOpenAttendance,
  onDownloadAttendees,
  downloadingExport,
  exportError,
}) => {
  const exportLabel =
    exportError === "forbidden"
      ? "No access to attendees"
      : exportError
      ? "Couldn't download attendees"
      : "Download Attendees (Excel)";
  return (
    <div
      className="d-inline-flex flex-nowrap align-items-center"
      style={{ gap: "0.25rem" }}
    >
      <OverlayTrigger
        overlay={<Tooltip id="products-edit-tooltip">Edit Event</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          onClick={() => {
            //console.log(row);
            openEditEventPage(row.workshop_id);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>

      <OverlayTrigger
        overlay={<Tooltip id="products-email-tooltip">Email Attendees</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          onClick={() =>
            openEmailAttendeesPage(
              row.workshop_id,
              row.workshop_name,
              row.fee,
              row.has_priced_options
            )
          }
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Mail.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>

      <OverlayTrigger
        overlay={
          <Tooltip id={`event-attendance-tooltip-${row.workshop_id}`}>
            Attendance
          </Tooltip>
        }
      >
        <button
          type="button"
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          aria-label="Attendance"
          onClick={onOpenAttendance}
        >
          <i aria-hidden="true" className="fa fa-user-check text-primary"></i>
        </button>
      </OverlayTrigger>

      <OverlayTrigger
        overlay={
          <Tooltip id={`event-export-tooltip-${row.workshop_id}`}>
            {exportLabel}
          </Tooltip>
        }
      >
        {/* A real button: reachable by keyboard, named for screen readers,
            and disabled while a download is in flight. */}
        <button
          type="button"
          className={`btn btn-icon btn-sm ${
            exportError ? "btn-light-danger" : "btn-light btn-hover-primary"
          }`}
          aria-label={downloadingExport ? "Downloading attendees" : exportLabel}
          disabled={downloadingExport}
          onClick={onDownloadAttendees}
        >
          {downloadingExport ? (
            <Spinner animation="border" size="sm" className="text-primary" />
          ) : (
            <i
              aria-hidden="true"
              className={`fa fa-file-excel ${
                exportError ? "text-danger" : "text-primary"
              }`}
            ></i>
          )}
        </button>
      </OverlayTrigger>

      {row.active_id === 1 &&
        (row.full_ind !== 1 ? (
            <OverlayTrigger
              overlay={
                <Tooltip id="products-delete-tooltip">
                  Mark as Full
                </Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-light btn-hover-danger btn-sm"
                onClick={() => openEventFullDialog(row.workshop_id)}
              >
                <span className="svg-icon svg-icon-md svg-icon-danger">
                <i className="fa fa-box-open text-primary"></i>
                </span>
              </a>
            </OverlayTrigger>
          ) : (
            <OverlayTrigger
              overlay={
                <Tooltip id="products-delete-tooltip">
                  Mark as Not Full
                </Tooltip>
              }
            >
              <a
                className="btn btn-icon btn-danger btn-hover-primary btn-sm"
                onClick={() => openEventNotFullDialog(row.workshop_id)}
              >
                <span className="svg-icon svg-icon-md svg-icon-danger">
                <i className="fa fa-box text-default"></i>
                </span>
              </a>
            </OverlayTrigger>
          ))}

      {row.active_id === 1 ? (
        <OverlayTrigger
          overlay={
            <Tooltip id="products-delete-tooltip">Deactivate Event</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={() => openDeleteEventDialog(row.workshop_id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-danger">
              <i className="fa fa-power-off text-success"></i>
            </span>
          </a>
        </OverlayTrigger>
      ) : (
        <OverlayTrigger
          overlay={
            <Tooltip id="products-delete-tooltip">Activate Event</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={() => openActivateEventDialog(row.workshop_id)}
          >
            <i className="fa fa-power-off"></i>
          </a>
        </OverlayTrigger>
      )}

      {row.active_id === 1 && (
        <OverlayTrigger
          overlay={
            <Tooltip id="products-duplicate-tooltip">Duplicate Event</Tooltip>
          }
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm"
            onClick={() => openDuplicateEventPage(row.workshop_id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-danger">
              <i className="far fa-copy text-success"></i>
            </span>
          </a>
        </OverlayTrigger>
      )}
    </div>
  );
};
